/* kk-bf.js (v4.71, 2026-10-28, Black Friday month): (1) cart gift picker of snippets/kk-bf (part 'cart') - "Geschenke gratis
   hinzufügen" adds every missing gift of the reached tier in one click (pillow / protector size from the row select, guide and spray
   fixed) through KK.cart.add with the line properties _bf (code), _set (bf_set_flag) and _promo, then re-renders the drawer;
   on /cart (no drawer) the page reloads. (2) phones: sticky bottom bar "Noch X € bis 2 Geschenke" (part 'sticky'), fed from
   /cart.js; gift lines (_bf) and gift cards never count. Hidden while the PDP sticky ATC is on (html.kk-stickybar-on) or the
   drawer is open. Tap = opens the cart drawer (cart not empty) or the gift page. (3) e-book auto add / remove (see below). */
(function () {
  if (window.__kkBf) return; window.__kkBf = true;
  var FALLBACK = 'Das Geschenk konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.';
  function sections() {
    var s = [], d = document.querySelector('cart-drawer[data-section-id]');
    if (d) s.push(d.getAttribute('data-section-id'));
    s.push('header');
    return s.join(',');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bf-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var root = btn.closest('[data-bf-pick]'), err = root.querySelector('[data-bf-err]');
    var set = root.getAttribute('data-set') || '';
    var lines = [];
    root.querySelectorAll('[data-bf-row]').forEach(function (row) {
      var sel = row.querySelector('[data-bf-variant]');
      var id = Number(sel ? sel.value : row.getAttribute('data-variant'));
      if (!id) return;
      /* _bf_i: every gift unit gets its own cart line, so each tier discount (one unit each) has its own line to price at 0 */
      var props = { _bf: row.getAttribute('data-bf-code'), _bf_i: String(Date.now() % 100000 + lines.length), _promo: 'gratis' };
      if (set) props._set = set;
      lines.push({ id: id, quantity: 1, properties: props });
    });
    if (!lines.length) return;
    if (err) err.textContent = '';
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer[data-section-id]');
    var run;
    if (window.KK && window.KK.cart && drawer) {
      run = lines.reduce(function (p, l) { return p.then(function () { return window.KK.cart.add(l, { sections: sections() }); }); }, Promise.resolve())
        .then(function () { if (window.KK.pubsub) window.KK.pubsub.publish('kk:drawer:open', { id: 'cart' }); });
    } else {
      run = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines })
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { var x = new Error('add'); x.userMessage = j && (j.description || j.message); throw x; }); location.reload(); });
    }
    run.catch(function (x) {
      if (err) err.textContent = (x && x.userMessage) || (window.KK && KK.i18n && KK.i18n.cartAddError) || FALLBACK;
    }).finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); refresh(); });
  });

  /* (3) Greta 28.10: the e-book needs no choice, so the cart part renders a hidden marker [data-bf-auto] - "add" once a tier
     is reached and the guide line is missing, "remove" when the guide line is no longer covered. Handled once per marker;
     the same action is never retried within 8 s, so a failing add can never loop (and /cart only reloads on success). */
  var last = {};
  function auto() {
    var m = document.querySelector('[data-bf-auto]:not([data-done])');
    if (!m) return;
    m.setAttribute('data-done', '1');
    var act = m.getAttribute('data-bf-auto'), sig = act + ':' + (m.getAttribute('data-variant') || m.getAttribute('data-key'));
    var now = Date.now(); if (last[sig] && now - last[sig] < 8000) return; last[sig] = now;
    var drawer = document.querySelector('cart-drawer[data-section-id]'), root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var useKK = !!(window.KK && KK.cart && drawer);
    var run;
    if (act === 'add') {
      var props = { _bf: 'guide', _bf_i: String(now % 100000), _promo: 'gratis' }, set = m.getAttribute('data-set');
      if (set) props._set = set;
      var line = { id: Number(m.getAttribute('data-variant')), quantity: 1, properties: props };
      if (!line.id) return;
      run = useKK ? KK.cart.add(line, { sections: sections() })
        : fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [line] }) })
            .then(function (r) { if (r.ok) location.reload(); });
    } else if (act === 'remove') {
      var key = m.getAttribute('data-key'), q = Number(m.getAttribute('data-qty')) || 0;
      run = useKK ? KK.cart.change(key, q, { sections: sections() })
        : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
            .then(function (r) { if (r.ok) location.reload(); });
    }
    if (run) run.catch(function () {});
  }
  function watchAuto() {
    auto();
    new MutationObserver(function () { if (document.querySelector('[data-bf-auto]:not([data-done])')) setTimeout(auto, 50); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchAuto); else watchAuto();

  /* sticky bar */
  var bar = null, txt = null, busy = false;
  function fmt(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var loc = document.documentElement.lang || 'de';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: 2 }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function rate() {
    var c = window.Shopify && Shopify.currency;
    if (!c || !c.active || c.active === 'EUR') return 1;
    var r = Number(c.rate) || 0; return r ? r * 1.03 : 0;
  }
  function paint(cartJson) {
    if (!bar) return;
    if (!document.documentElement.classList.contains('kk-bf')) { bar.hidden = true; return; }
    var t1 = Number(bar.getAttribute('data-t1')), t2 = Number(bar.getAttribute('data-t2'));
    var n1 = bar.getAttribute('data-n1'), n2 = bar.getAttribute('data-n2');
    var r = rate(); if (!r) { bar.hidden = true; return; }
    t1 = Math.round(t1 * r); t2 = Math.round(t2 * r);
    var v = 0, items = (cartJson && cartJson.items) || [];
    items.forEach(function (it) { if (!(it.properties && it.properties._bf) && !it.gift_card) v += it.final_line_price; });
    var s;
    if (!items.length) s = bar.getAttribute('data-txt0');
    else if (v < t1) s = bar.getAttribute('data-txtmore').replace('%a%', '<b>' + fmt(t1 - v) + '</b>').replace('%n%', n1);
    else if (Number(n2) > 0 && v < t2) s = bar.getAttribute('data-txtmore').replace('%a%', '<b>' + fmt(t2 - v) + '</b>').replace('%n%', n2);
    else s = bar.getAttribute('data-txtdone').replace('%n%', Number(n2) > 0 ? n2 : n1);
    txt.innerHTML = s;
    bar.hidden = false;
    bar.setAttribute('data-empty', items.length ? '0' : '1');
  }
  function refresh() {
    if (!bar || busy) return; busy = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(paint).catch(function () {}).finally(function () { busy = false; });
  }
  function init() {
    bar = document.querySelector('[data-bf-sticky]'); if (!bar) return;
    txt = bar.querySelector('[data-bf-sticky-txt]');
    bar.addEventListener('click', function () {
      if (bar.getAttribute('data-empty') === '0' && window.KK && KK.pubsub && document.querySelector('cart-drawer')) KK.pubsub.publish('kk:drawer:open', { id: 'cart' });
      else location.href = bar.getAttribute('data-link');
    });
    refresh();
    /* cart changes: any /cart/add|change|update|clear request -> repaint */
    var f = window.fetch;
    if (f && !f.__kkBf) {
      var w = function (input) {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var p = f.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 300); }, function () {});
        return p;
      };
      w.__kkBf = true; window.fetch = w;
    }
    /* drawer open = hide the bar (the drawer shows the progress itself) */
    var mo = new MutationObserver(function () {
      var d = document.querySelector('cart-drawer');
      var open = !!(d && (d.hasAttribute('open') || d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false'));
      document.documentElement.classList.toggle('kk-bf-drawer', open);
    });
    var d = document.querySelector('cart-drawer');
    if (d) mo.observe(d, { attributes: true, subtree: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
